import styled from 'styled-components';
import RupeeIcon from '../../../icons/Rupee';

export const ListingSection = styled.div`
  width: 300px;
  background: #fff;
  float: right;
  position: relative;
`;

export const TopBannerSection = styled.div`
  height: 110px;
  width: 100%;
  padding: 15px 10px;
  color: #fff;
  position: relative;
  border-radius: 4px 0px 0px 0px;
  /* background-color: rgba(104, 8, 227, 0.5); */
  // & .bannerMasking{
  //   background-color: rgba(104,8,227,0.5);
  //   position: absolute;
  //   top: 0px;
  //   width: 100%;
  //   height: 100%;
  //   left: 0px;
  // }
`;

export const DestinationsContainer = styled.div``;

export const SortBySection = styled.div`
  padding: 14px 25px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
  background: #fff;
  & .sortByarrow {
    border: solid #2276e3;
    border-width: 0 0px 2px 2px;
    display: inline-block;
    padding: 2px;
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    content: '';
    position: relative;
    right: -1px;
    top: -1px;
  }
  & .sortByoptions {
    background: #fff;
    padding: 5px 10px;
    list-style-type: none;
    box-shadow: 0px 0px 6px #ddd;
    position: absolute;
    z-index: 1;
    right: -10px;
    top: -10px;
    border-radius: 6px;
    & li {
      padding: 5px 0;
      cursor: pointer;
      font-weight: 700;
      &.active {
        color: #2276e3;
      }
    }
  }
`;

export const Container = styled.div`
  height: calc(100vh - 295px);
  overflow-y: auto;
  background: #eee;
`;

export const ListingOuter = styled.div`
  background: #fff;
  &.errorState {
    height: 100%;
    padding: 0 20px;
    text-align: center;
  }
  & .viewAllfliBtn {
    background: #f16824;
    border-radius: 80px;
    color: #fff;
    padding: 8px 17px;
    font-size: 12px;
    text-transform: uppercase;
    display: inline-block;
    margin-bottom: 1rem;
  }
`;

export const ListWrap = styled.div`
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  justify-content: space-between;
  padding-left: 25px;
  padding-right: 10px;
  border-right: 4px solid #fff;
  cursor: pointer;
  &:hover {
    background: rgba(34, 118, 227, 0.05);
    border-right: 4px solid #2276e3;
  }
  &.active {
    background: #0b69e3;
    border-right: 4px solid #0b69e3;
  }
  &.active .pricing,
  &.active ${RupeeIcon}, &.active .heading,
  &.active .subheading,
  &.active .fromto,
  &.active .stops,
  &.active .rtSubHeading {
    color: #fff;
    fill: #fff;
  }
  &.active .arrow {
    border: solid #fff;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 2px;
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    content: '';
    position: absolute;
    right: -5px;
    top: 6px;
  }
`;

export const LeftSection = styled.div`
  width: 70px;
  margin-right: 10px;
  & .listingImgLoading {
    background: #e8e9eb;
    border-radius: 6px;
    width: 100%;
    height: 70px;
    display: inline-block;
  }
`;

export const RightSection = styled.div`
  flex: 1;
  & .heading {
    color: #000;
    font-weight: 700;
    font-size: 12px;
    width: 113px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    &.loadingShimmer {
      background: #8e93ab;
      opacity: 0.1;
      height: 16px;
      width: 90px;
      border-radius: 4px;
    }
  }
  & .subheading {
    color: #000;
    font-weight: 700;
    font-size: 10px;
    width: 115px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    &.loadingShimmer {
      background: #8e93ab;
      opacity: 0.1;
      height: 10px;
      width: 90px;
      border-radius: 4px;
    }
  }
  & .rtSubHeading {
    color: #000;
    font-weight: 700;
    font-size: 10px;
    width: 60px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  & .fromto {
    color: #000;
    font-size: 9px;
    &.loadingShimmer {
      background: #8e93ab;
      opacity: 0.1;
      height: 10px;
      width: 90px;
      border-radius: 4px;
    }
  }
  & .stops {
    color: #8e93ab;
    font-size: 9px;
    &.loadingShimmer {
      background: #8e93ab;
      opacity: 0.1;
      height: 10px;
      width: 90px;
      border-radius: 4px;
    }
  }
  & .pricing {
    color: #0b69e3;
    font-size: 14px;
    font-weight: 700;
    position: relative;
    width: 65px;
    text-align: right;
    &.loadingShimmer {
      background: #0b69e3;
      opacity: 0.1;
      height: 16px;
      border-radius: 4px;
    }
  }
  & .dateTag {
    background: #fff5dc;
    border-radius: 4px;
    padding: 2px 4px;
    font-size: 10px;
    color: #d1820b;
    font-weight: 700;
    &.loadingShimmer {
      background: #ffce50;
      width: 46px;
      opacity: 0.1;
      height: 16px;
      border-radius: 4px;
    }
  }
  & .timeTag {
    background: #eaeef4;
    border-radius: 4px;
    padding: 2px 4px;
    font-size: 10px;
    color: #8e93ab;
    font-weight: 700;
    text-align: center;
    &.loadingShimmer {
      background: #8e93ab;
      opacity: 0.1;
      height: 15px;
      border-radius: 4px;
      width: 45px;
    }
  }
  & .arrow {
    border: solid #0b69e3;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 2px;
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    content: '';
    position: absolute;
    right: -5px;
    top: 6px;
  }
`;

export const ContentSectionWrap = styled.div`
  padding: 15px 15px 15px 25px;
  border-right: 5px solid #ddd;
  & .contentHead {
    background: #eee;
    padding: 4px 7px;
    font-size: 10px;
    font-weight: 700;
    color: #141823;
  }
  & .contentSection {
    & .searchTabsBtn {
      border: 1px solid #ddd;
      color: #0b69e3;
      font-size: 10px;
      width: 120px;
      padding: 9px 10px;
      box-sizing: border-box;
      border-radius: 2px;
    }
    & .faqSection {
      border-bottom: 1px solid #e1e7ee;
      padding: 7px 0px;
      &:last-child {
        border: none;
        padding: 7px 0 0 0;
      }
      & .faqArrow {
        border: solid #8e93ab;
        border-width: 0px 2px 2px 0px;
        display: inline-block;
        padding: 2px;
        -webkit-transform: rotate(-45de);
        -ms-transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
        content: '';
        &.arrowDown {
          border-width: 0px 0px 2px 2px;
        }
      }
    }
  }
  &.contentGreen {
    border-right: 5px solid #14afc5;
    & .contentHead {
      background: rgba(20, 175, 196, 0.1);
      color: #14afc4;
    }
  }
  &.contentDarkBlue {
    border-right: 5px solid #58668d;
    & .contentHead {
      background: rgba(88, 102, 141, 0.1);
      color: #58668d;
    }
  }
  &.contentBrown {
    border-right: 5px solid #a06271;
    & .contentHead {
      background: rgba(160, 98, 113, 0.1);
      color: #a06271;
    }
  }
`;
